import { Dispatch } from 'redux'
import { loginUser } from '../../../api/auth'
import { RouteType } from '../../../types/routes'
import { getUrlWithSalonGuid } from '../../../utils/urlParams'
import { userLogin } from '../../../store/user/actions'
import { setLocalStorageRefreshToken, setLocalStorageUserToken } from '../../../utils/localStorage'

type SubmitLoginProps = {
  email: string
  password: string
  salonGuid: string
  setErrors?: (errors: string) => void
  dispatch: Dispatch
  navigate?: (path: string) => void
  redirectRoute?: RouteType
}

export const submitLogin = async ({ email, password, salonGuid, setErrors, dispatch, navigate, redirectRoute }: SubmitLoginProps) => {
  if (setErrors) {
    if (!email) {
      setErrors('Bitte geben Sie Ihre E-Mail-Adresse ein')
      return
    }

    if (!password) {
      setErrors('Bitte geben Sie Ihr Passwort ein')
      return
    }
  }

  const response = await loginUser({
    email,
    password,
    salonGuid
  })

  if (response === null) {
    if (setErrors) setErrors('No server response')
    return
  }

  if ('token' in response && 'benutzer' in response) {
    dispatch(userLogin(response.benutzer))
    setLocalStorageUserToken(response.token)
    setLocalStorageRefreshToken(response.refreshToken)
    if (navigate && redirectRoute) {
      navigate(getUrlWithSalonGuid(redirectRoute))
    }
  } else if (setErrors) setErrors(response.message)
}
